import {Component, Input} from '@angular/core';
import {EtablissementData, menuAddress} from "../../utils/data/etablissments-data";
import {CustomDialogComponent} from "../../custom-dialog/custom-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {AddressService} from "../../../services/address.service";
import {AuthService} from "../../../services/auth.service";
import {FlagService} from "../../services/flag.service";
import {FlagType} from "../../utils/enums";
import {
  AddSiteComponent
} from "../../../pages/etablissement/mon-etablissement/components/sites-adresses/components/add-site/add-site.component";

@Component({
  selector: 'app-address-menu',
  templateUrl: './address-menu.component.html',
  styleUrl: './address-menu.component.scss'
})
export class AddressMenuComponent {
@Input() data: any = undefined;
@Input() column: any = undefined;
  protected readonly menuAddress = menuAddress;

  constructor(private dialog: MatDialog,
              private flag: FlagService,
              private addressService: AddressService,
              private auth: AuthService) {
  }

  menuClick(id: number) {
    switch (id) {
      case 1: {
        this.defineSocial()
        break;
      }
      case 2: {
        this.openAddSiteDialog()
        break;
      }
      case 3: {
        this.hideSiteDialog()
        break;
      }
      case 4: {
        this.hideSiteDialog()
        break;
      }
    }
  }

  openAddSiteDialog() {
    const dialog = this.dialog.open(AddSiteComponent, {
      width: '700px',
      autoFocus: false,
      data: {
        isModify: true,
        site: this.data
      }
    })
    dialog.afterClosed().subscribe(value => {
      if (value) {
        this.addressService.toggleRefreshData();
      }
    })
  }

  defineSocial() {
    const body = {
      establishementId: this.auth.id,
      adresseId: this.data.id,
      isSocial: true
    }
    this.addressService.updateAddressSocial(body).subscribe({
      next: (res) => {
        this.flag.displayFlag(`le site ${this.data.name} est défini comme siège social `, FlagType.success)
        this.addressService.toggleRefreshData();
      }
    })
  }

  hideSiteDialog() {
    const dialogRef  = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.monEtablissement.hideStatusDialog.title,
        description: EtablissementData.monEtablissement.hideStatusDialog.description,
        primaryLabel: this.data.isvisible ? EtablissementData.monEtablissement.hideStatusDialog.primaryButtonHide :
          EtablissementData.monEtablissement.hideStatusDialog.primaryButtonShow,
        secondaryLabel: EtablissementData.monEtablissement.hideStatusDialog.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false
    })
    dialogRef .afterClosed().subscribe(res => {
      if (res) {
        const body = {
          etablissementId: this.auth.id,
          id: this.data.id,
          isVisible: !this.data.isvisible,
        }
        this.addressService.hideSite(body).subscribe({
          next: value => {
            this.addressService.toggleRefreshData();
          }
        })
      }
    })
  }
}
